interface UseMapLayersProps {
  isStyleLoaded: boolean;
  type: string;
  selectedGroup: {
    type: string;
    group: string;
  } | null;
}

export const useMapLayers = ({ isStyleLoaded, type, selectedGroup }: UseMapLayersProps) => {
  const isFarmersGroup = isStyleLoaded && !selectedGroup && (type === 'farmers' || type === '');
  const isFactoriesGroup = isStyleLoaded && !selectedGroup && (type === 'factories' || type === '');
  const isForestsGroup = isStyleLoaded && !selectedGroup && (type === 'forests' || type === '');

  const isFarmers = isStyleLoaded && selectedGroup?.type === 'farmers';
  const isForests = isStyleLoaded && selectedGroup?.type === 'forests';
  const isFactories = isStyleLoaded && selectedGroup?.type === 'factories';
  const isSpecificForests =
    isStyleLoaded && selectedGroup?.type === 'forests' && selectedGroup.group !== 'Trees, Ethiopia';

  return {
    isFarmersGroup,
    isFactoriesGroup,
    isForestsGroup,
    isFarmers,
    isForests,
    isFactories,
    isSpecificForests,
  };
};
